import {CSSProperties, FC} from 'react';


export interface IIconTiktokProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconTiktok: FC<IIconTiktokProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M0 12C0 5.374 5.374 0 12 0s12 5.374 12 12-5.374 12-12 12S0 18.626 0 12Zm18.329-1.49c.131-.001.263-.008.394-.02l.002-.001v-2.67A4.279 4.279 0 0 1 14.781 4h-2.297l-.024 11.197c0 1.373-1.213 2.455-2.587 2.455a2.487 2.487 0 0 1 0-4.973c.074 0 .145.01.217.02l.084.011v-2.402l-.084-.005c-.072-.005-.144-.01-.217-.01A4.872 4.872 0 0 0 5 15.166a4.872 4.872 0 1 0 9.746 0V8.573a4.283 4.283 0 0 0 3.583 1.937Z" clipRule="evenodd" />
        </svg>
    );
};
